import { Controller } from "@hotwired/stimulus";
import "formiojs/dist/formio.full.min.js";
import $ from "jquery";
import "jquery-serializejson/jquery.serializejson.js";
import CustomFileUpload from "../../../../../../services/custom_file_upload";
import {
  parse_to_json,
  save_data_to_local_storage,
} from "../../../../../dashboard/javascript/utils";
import {
  autoSave,
  formSubmitButtonsInit,
  removeRadioButtonsAndCheckboxes,
  updateFormCheckboxes
} from "./utils";
import {
  filterFormSections,
  populateFormSections,
} from "../../../../../applications/sections/form_sections";

export default class extends Controller {
  static values = {
    formJson: String,
    formData: Object,
    isReadOnly: Boolean,
    sectionsData: String
  };

  static targets = ["formContainer", "signatureSigned"];

  connect() {
    this.initializeForm();
  }

  initialize() {
    this.submission = {};
    this.form = {};
  }

  async initializeForm() {
    this.form = await Formio.createForm(
      this.formContainerTarget,
      parse_to_json(parse_to_json(this.formJsonValue)),
      {
        readOnly: this.isReadOnlyValue,
        fileService: new CustomFileUpload(),
      }
    );

    this.form.submission = { data: this.formDataValue };
    this.submission = this.form.submission;

    this.initialSubmission = { ...this.formDataValue };
    this.warningShown = false;

    formSubmitButtonsInit(this.submission);
    removeRadioButtonsAndCheckboxes("#formio-form");
    updateFormCheckboxes("formio-form");
    this.createFormSections();

    let initialFormLoad = true;
    let typingTimer;  // Timer identifier
    const typingDelay = 1000;

    this.form.on("change", (submission) => {
      if(initialFormLoad && submission.changed) {
        initialFormLoad = false;
        return;
      }

      if (submission.changed?.component?.type === 'signature' && this.hasSignatureSignedTarget) {
        const hasSignature = !!submission.data[submission.changed.component.key];
        this.signatureSignedTarget.value = hasSignature ? "true" : "false";
      }

      this.setFormSubmission(submission);
      clearTimeout(typingTimer);  // Clear the timer on each key stroke

      const $this = this;

      typingTimer = setTimeout(async () => {
        if (!initialFormLoad && submission.changed) {
          try {
            const updated_submission_json = await $this.handleAutoSave(submission);
            if (updated_submission_json) {
              if (!$this.warningShown && $this.hasSignatureBeenCleared(updated_submission_json)) {
                $this.showSignatureWarning();
                $this.warningShown = true;
              }

              initialFormLoad = true;
            }
          } catch (e) {
            console.error("Autosave failed", e);
          }
        }
      }, typingDelay);

      this.handleFormOnChange(submission)
    });

    $(".formio-component").on("click", (event) => {
      removeRadioButtonsAndCheckboxes("#formio-form");
    });

    this.form.nosubmit = true;
  }

  handleAutoSave(submission) {
    return new Promise((resolve) => {
      autoSave(submission, (updated_submission_json) => {
        window.__context.form_progressbar("progressbar");
        resolve(updated_submission_json);
      });
    });
  }

  handleFormOnChange(submission) {
    removeRadioButtonsAndCheckboxes("#formio-form");
    updateFormCheckboxes("formio-form");
    $("#formio-submission-footer").removeClass("hidden");
  }

  setFormSubmission(submission) {
    this.submission = submission;
    $("#submission-json").val(JSON.stringify(submission.data));
  }

  createFormSections() {
    if (!document.getElementById("sections")) return;

    save_data_to_local_storage(
      "sections",
      filterFormSections(this.form.components)
    );

    populateFormSections();
  }

  showOrHideWizardNavButtons(page = null, lastPage = null) {
    let next_button = $(".form-next-btn");
    let previous_button = $(".form-prev-btn");

    next_button.addClass("hidden");
    previous_button.addClass("hidden");
  }

  showSignatureWarning() {
    const warningCard = document.getElementById("insurance-application-signature-warning");
    if (warningCard) warningCard.classList.remove("tw-hidden");
  }

  hasSignatureBeenCleared(updated) {
    const initial = this.initialSubmission;
    const keys = Object.keys(initial).filter((key) =>
      key.toLowerCase().includes("signature")
    );

    if (keys.length === 0) return false;

    return keys.some((key) => {
      return initial[key] !== "" && updated[key] === "";
    });
  }
}
